import * as React from 'react';
import { Button, Input, Modal, TextBox } from '../..';
import { useAuth } from '../../../context/authContext';
import {
  Brand,
  storePreferenceFormAction,
} from '../../../context/storeContext';
import useValidator from '../../../hooks/useValidator';
import { Option } from '../../Inputs/SelectInput/SelectInput';

type ModalProps = {
  onCloseModal: () => void;
  onSetAddedValue: (option: Option) => void;
  brands: Brand[];
};

function BrandAdd({ onCloseModal, onSetAddedValue, brands }: ModalProps) {
  const [{ user, storePreferences }, dispatch] = useAuth();
  const [brand, setBrand] = React.useState({
    name: '',
    description: '',
    logo: '',
  });
  const [status, setStatus] = React.useState<
    'IDLE' | 'LOADING' | 'RESOLVED' | 'REJECTED'
  >('IDLE');
  const [validator, showValidationMessage] = useValidator({});

  const handleBrandInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;

    setBrand(fndBrand => ({
      ...fndBrand,
      [name]: value,
    }));
  };

  const handleBrandSave = async () => {
    if (!validator.allValid()) {
      showValidationMessage(true);
      return;
    }

    setStatus('LOADING');

    const storeId = user?.defaultStore?.id;

    const { brand: getAddedBrand } = (await storePreferenceFormAction(
      `/brand?store=${storeId}`,
      'post',
      { ...brand, storeId },
    )) as any;

    if (storePreferences && getAddedBrand) {
      dispatch({
        type: 'SET_STORE_PREFERENCES',
        payload: {
          ...storePreferences,
          brands:
            storePreferences.brands.length > 0
              ? [getAddedBrand, ...storePreferences.brands]
              : [getAddedBrand],
        },
      });
    }

    onSetAddedValue({ value: getAddedBrand.id, label: getAddedBrand.name });

    setStatus('RESOLVED');
    onCloseModal();
  };

  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-md bg-white w-[500px]">
        <form>
          <div className="flex flex-col p-5">
            <h3
              className="text-pos-black text-[20px] font-semibold mb-2
              inline-flex whitespace-pre"
            >
              Add New Brand
            </h3>
            <div className="text-pos-black text-sm mt-2 mb-2 font-normal space-y-4">
              <div>
                <label htmlFor="name" className="text-xbase block mb-1">
                  Name{' '}
                  <span className="text-xs font-light text-pos-red">*</span>
                </label>
                <Input
                  id="name"
                  name="name"
                  value={brand.name}
                  onChange={handleBrandInputChange}
                />
                {validator.message('name', brand.name, 'required|min:3', {
                  messages: {
                    required: 'Brand name is required.',
                  },
                  className:
                    'text-pos-red text-left text-[13px] leading-[0.9rem] mt-[10px] ml-1',
                })}
              </div>
              <div>
                <label htmlFor="description" className="text-xbase block mb-1">
                  Description
                </label>
                <TextBox
                  id="description"
                  name="description"
                  value={brand.description}
                  rows={3}
                  onChange={handleBrandInputChange}
                />
              </div>
            </div>
            <div className="mt-4 text-center flex flex-row ml-auto space-x-4">
              <Button
                label="Save"
                onClick={handleBrandSave}
                type="button"
                disabled={status === 'LOADING'}
                loading={status === 'LOADING'}
                className="!bg-pos-green border border-[rgba(27,31,36,0.15)] min-w-[150px]  h-[40px]
                      items-center justify-center text-white text-xbase
                      shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default BrandAdd;
